import React, { FC, useEffect, useState } from 'react'

import { Container } from '@material-ui/core'

import TabPanel from '~/components/shared/TabPanel'

import { getWizardFormStepTitles, isHideNavigation } from '~/utils/functions'

import { WizardProps } from './types'
import useWizardState from './useWizardState'
import { WizardContext } from './wizard.context'
import WizardNavigation from './WizardNavigation'

const WizardForm: FC<WizardProps> = ({
  steps,
  hideNavigation,
  defaultStore,
  scrollToTopModal,
  edit,
  isHidePackages,
  isListingForm,
  closeModal,
  ...rest
}) => {
  const [store, setStore] = useState<any>(defaultStore)
  const {
    state,
    onNext,
    onBack,
    setStep,
    setSubStep,
    onDraft
  } = useWizardState({
    store,
    setStore,
    isListingForm,
    stepTitles: getWizardFormStepTitles(steps)
  })

  const handleChangeStep = (_e, step: number): void => {
    setStep(step)
  }

  useEffect(() => {
    if (scrollToTopModal) scrollToTopModal()
  }, [state])

  const isShowNavigation =
    !hideNavigation && !isHideNavigation(isHidePackages, state.step)

  return (
    <>
      <WizardContext.Provider
        value={{ state, setStep, setSubStep, store, setStore }}
      >
        {isShowNavigation && (
          <WizardNavigation
            step={state.step}
            completed={state.completed}
            onChange={handleChangeStep}
            isListingForm={isListingForm}
            steps={steps}
            edit={edit}
          />
        )}
        {steps.map((tab, index) => {
          const { component: Component } = tab

          return (
            <TabPanel key={index} value={state.step} index={index}>
              <Container maxWidth="xl">
                <Component
                  onNext={() => onNext(index)}
                  onBack={() => onBack(index)}
                  step={state.subStep}
                  onDraft={onDraft}
                  edit={edit}
                  store={store}
                  setStep={setSubStep}
                  closeModal={closeModal}
                  {...rest}
                />
              </Container>
            </TabPanel>
          )
        })}
      </WizardContext.Provider>
    </>
  )
}

export default WizardForm
